module.exports = __webpack_public_path__ + "static/img/icon1.3769dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon1.png
// module id = d0yY
// module chunks = 1